import FilteredResultsControls from './FilteredResultsControls';
export default FilteredResultsControls;